import { IIdentifiable } from '@/common/models/models'

interface ISchedulePeriod extends IIdentifiable {
    name: string
    active: boolean
}

class SchedulePeriod implements ISchedulePeriod {
    id = 0
    name = ''
    active = false

    // TODO: Rename to copy_from or something
    period: number | null = null

    constructor (dto?: ISchedulePeriod) {
        if (dto) {
            this.id = dto.id
            this.name = dto.name
            this.active = dto.active
        }
    }
}

export {
    ISchedulePeriod, SchedulePeriod
}
